import { ArrowRight, Check } from "lucide-react";
import { useTranslation } from "@thyra/landing-i18n";
import { getAppUrl } from "../env";

const REASSURANCE = ["fastSetup", "noCard", "approval"] as const;

export function CTASection() {
  const { t } = useTranslation("sections");
  return (
    <section className="w-full py-16 sm:py-24">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <div
          className="relative overflow-hidden rounded-3xl px-6 py-14 text-center shadow-[0_24px_60px_-20px_rgba(24,38,72,0.5)] sm:px-12 sm:py-20"
          style={{ background: "var(--gradient-cta-band)" }}
        >
          {/* Dotted texture + top glow */}
          <div
            className="pointer-events-none absolute inset-0 opacity-40"
            style={{
              backgroundImage:
                "radial-gradient(rgba(255,255,255,0.22) 1px, transparent 1px)",
              backgroundSize: "20px 20px",
              maskImage:
                "radial-gradient(ellipse 80% 90% at 50% 0%, #000 30%, transparent 100%)",
              WebkitMaskImage:
                "radial-gradient(ellipse 80% 90% at 50% 0%, #000 30%, transparent 100%)",
            }}
            aria-hidden
          />
          <div
            className="pointer-events-none absolute left-1/2 top-[-6rem] h-48 w-[36rem] -translate-x-1/2 rounded-full bg-white/20 blur-3xl"
            aria-hidden
          />

          <div className="relative">
            <h2 className="mx-auto max-w-2xl text-balance text-3xl font-semibold tracking-tight text-white sm:text-4xl md:text-5xl">
              {t("cta.title")}
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-base leading-7 text-blue-100/90 sm:text-lg">
              {t("cta.description")}
            </p>

            <div className="mt-9 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <a
                href={getAppUrl()}
                className="group inline-flex h-12 w-full max-w-xs items-center justify-center gap-2 rounded-xl bg-white px-8 text-sm font-semibold text-[var(--blue-700)] shadow-[inset_0_-2px_0_rgba(24,38,72,0.12),0_8px_24px_-8px_rgba(24,38,72,0.6)] transition-transform hover:scale-[1.02] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/60 sm:w-auto"
              >
                {t("cta.button")}
                <ArrowRight
                  className="h-4 w-4 transition-transform group-hover:translate-x-0.5"
                  strokeWidth={2}
                />
              </a>
            </div>

            <ul className="mx-auto mt-8 flex max-w-lg flex-col items-center gap-3 sm:max-w-none sm:flex-row sm:flex-wrap sm:justify-center sm:gap-6">
              {REASSURANCE.map((item) => (
                <li
                  key={item}
                  className="flex items-center gap-2 text-sm font-medium text-blue-50/95"
                >
                  <Check className="h-4 w-4 shrink-0 text-blue-200" />
                  {t(`cta.reassurance.${item}`)}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
